import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Linkedin, ArrowRight } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0F2B4C] text-slate-300" data-testid="site-footer">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center space-x-3 mb-5">
              <img
                src="https://customer-assets.emergentagent.com/job_techkids-learn-1/artifacts/2efozgua_471419268_122203530860204093_7119326466186742520_n-2.jpg"
                alt="Ludotech Robotics Logo"
                className="h-12 w-auto"
              />
              <span className="font-heading text-lg font-extrabold text-white">Ludotech Robotics</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Nous inspirons la prochaine génération d'innovateurs à travers la robotique et la programmation dans un environnement ludique et créatif.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-5">Liens rapides</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Accueil', path: '/' },
                { label: 'Programmes', path: '/programmes' },
                { label: 'Partenariat Écoles', path: '/partenariat-ecole' },
                { label: 'Activités', path: '/activites' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-[#F97316] transition-colors text-sm flex items-center group"
                  >
                    <ArrowRight size={12} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-5">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-[#F97316] mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">Espace Orange, Air France 3, Bouaké Côte d'Ivoire</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={16} className="text-[#1B6FE3] flex-shrink-0" />
                <span className="text-slate-400 text-sm">+225 0718463949</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={16} className="text-[#F97316] flex-shrink-0" />
                <span className="text-slate-400 text-sm">contact@ludotech-robotics.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-5">Suivez-nous</h4>
            <div className="flex space-x-2.5">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-[#1B6FE3] p-2.5 rounded-lg transition-all duration-200" data-testid="facebook-link">
                <Facebook size={18} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-[#1B6FE3] p-2.5 rounded-lg transition-all duration-200" data-testid="linkedin-link">
                <Linkedin size={18} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-5">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
            <p>&copy; 2026 <span className="text-white font-semibold">Ludotech Robotics</span>. Tous droits réservés.</p>
            <div className="flex space-x-4 mt-2 md:mt-0">
              <Link to="/login" className="hover:text-slate-300 transition-colors">Administration</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
